import { render, staticRenderFns } from "./qaFeedback.vue?vue&type=template&id=1b41a674&scoped=true"
import script from "./qaFeedback.vue?vue&type=script&lang=js"
export * from "./qaFeedback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b41a674",
  null
  
)

export default component.exports